// src/plugins/i18n.ts
import { createI18n } from 'vue-i18n';

const requireLocale = require.context('@/i18n', true, /\.json$/);

const messages: Record<string, any> = {};

requireLocale.keys().forEach((fileName) => {
  const locale = fileName.replace('./', '').replace('.json', '');
  messages[locale] = requireLocale(fileName).default || requireLocale(fileName);
});

const i18n = createI18n({
  locale: 'cn',  // 默认语言，和文件名保持一致
  fallbackLocale: 'en',
  messages,
});

export default i18n;
